(function() {
    function funcReady() {
        $('.KRP0036').buildCommonUI();

        var KRP0036 = {
            init: function(){
                var self = this;
                self.$carousel = $('.KRP0036-list');

                // KRP0023 참고
                vcui.require(['ui/toggleCarousel'], function () {
                    self.$carousel.each(function() {
                        var opt = $(this).hasClass('slidesToShowMore') ?
                            {
                                pcOption: "unbuild",
                                cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                                touchThreshold: 100,
                                speed: 150,
                                mobileOption: {
                                    infinite: false,
                                    dots: true,
                                    slidesToShow: 1.28,
                                    slidesToScroll: 1,
                                    cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                                    speed: 150,
                                    touchThreshold: 100
                                }
                            }:{
                                pcOption: "unbuild",
                                cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                                touchThreshold: 100,
                                speed: 150,
                                mobileOption: {
                                    infinite: true,
                                    dots: true,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                                    speed: 150,
                                    touchThreshold: 100
                                }
                            };
                        $(this).find('.ui_carousel_slider2').vcToggleCarousel(opt);
                    })
                });
            },
        };

        KRP0036.init();


        // BTOCSITE-24981 신규 컴포넌트
        var infoDisclaimer = $('.KRC0025').find('.unit-box');

        infoDisclaimer.each(function(cdx, item){
            var titleAttr = $(item).find('.title').attr('id');
            var slideID = titleAttr;

            $(item).find('.drop-info .dropInfo_openBtn').on('click', function(e){
                var mybtnAttr = $(this).attr('aria-describedby', slideID);

                if(titleAttr = mybtnAttr) {
                    $(item).find('.dropContent').addClass('on');
                    $(this).hide();
                }
                $(this).parents('.drop-info').attr('data-sc-top', $(window).scrollTop());
            });

            $(item).find('.drop-info .dropInfo_closeBtn').on('click', function(e){
                var mybtnAttr = $(this).attr('aria-describedby', slideID);
                var winTop = $(window).scrollTop()
                    , currentTop = Number($(this).parents('.drop-info').attr('data-sc-top'));

                if(titleAttr = mybtnAttr) {
                    $(item).find('.dropContent').removeClass('on');
                    $(item).find('.drop-info .dropInfo_openBtn').show();
                }
                if(winTop !== currentTop && currentTop < winTop) {
                    $(window).scrollTop(currentTop);
                }
            });

        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'RENTAL', name: 'KRP0036-2.0.0', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0036')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0036')) return false;
        funcReady();
    });

})();